import React, { useState } from 'react';
import { Filter } from 'framework/list';
import { useDateService } from 'framework/utils';
import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import LeadNotificationButton from './LeadNotificationButton';

type NewLeadsResponse = {
  totalElements: number;
  result?: Array<{
    createdAt?: string;
  }>;
};

const getLabelDurationForLessThanHour = (minutesDifference: number) => {
  if (minutesDifference < 15) {
    return '< 15 minutes';
  } else if (minutesDifference >= 15 && minutesDifference < 30) {
    return '< 30 minutes';
  } else if (minutesDifference >= 30 && minutesDifference < 45) {
    return '< 45 minutes';
  } else {
    return '< 60 minutes';
  }
};

const NewLeadsNotificationButton = (props: {
  state: Filter;
  sx?: SystemStyleObject<Theme>;
  response: NewLeadsResponse;
}) => {
  const [styles, setStyles] = useState<SystemStyleObject<Theme>>({});
  const { getToday, getMinutesBetween } = useDateService();
  const today = getToday();

  const getLabel = ({ totalElements, result = [] }: NewLeadsResponse) => {
    const { createdAt } = result[0] || [];
    const minutesDifference = getMinutesBetween(today, createdAt);
    const hoursDifference = minutesDifference / 60;
    let labelDuration: string;
    const hasSeveralLeads = totalElements > 1;

    if (hoursDifference < 1) {
      labelDuration = getLabelDurationForLessThanHour(minutesDifference);
    } else if (hoursDifference >= 1 && hoursDifference < 24) {
      const flooredHours = Math.floor(hoursDifference);
      const unit = flooredHours === 1 ? 'hour' : 'hours';
      labelDuration = `${flooredHours}+ ${unit}`;

      if (hoursDifference > 9) {
        setStyles({ borderColor: 'background.error' });
      }
    } else {
      labelDuration = '24+ hours';
      setStyles({ borderColor: 'error.main' });
    }

    return `${totalElements} New lead${hasSeveralLeads ? 's have' : ' has'} been unassigned for ${labelDuration}`;
  };

  return (
    <LeadNotificationButton
      getLabel={getLabel}
      icon={<PersonAddAlt1OutlinedIcon sx={{ fontSize: 18, color: 'error.main' }} />}
      accentSoftColor="background.error"
      styles={{
        ...styles,
        '&.Mui-disabled': {
          ...styles,
        },
      }}
      {...props}
    />
  );
};

export default NewLeadsNotificationButton;
